import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { NzModalService } from 'ng-zorro-antd/modal';
import { NzCardModule } from 'ng-zorro-antd/card';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';

@Component({
  selector: 'nz-card-descricao-selos',
  standalone: true,
  imports: [NzCardModule],
  template: `
    <nz-card class=" py-[20px] px-[10px] dark:bg-white/10 dark:text-white/[.87] dark:border-white/10 rounded-[12px] " nzXs="24" nzMd="12" nzXXl="12" >
      <div class="flex flex-wrap gap-[20px] justify-center md:justify-start xl:justify-start 4xl:justify-start">
          <div class="flex items-center justify-center order-1 w-[110px] h-[100px] 4xl:w-[130px] 4xl:h-[120px] rounded-2xl">
            <img class="w-full h-full" src="{{icon}}.png">
          </div>
          <div class="flex flex-col justify-between order-2">
              <p class="w-full max-w-[850px] 4xl:max-w-[950px] xl:max-w-[950px] md:max-w-[500px] pt-[30px] pb-[30px]  font-normal font-Poppins text-light dark:text-white/60 text-13 4xl:text-15"> {{descricao}}</p>
          </div>
        </div>
    </nz-card>

  `
})

export class CardDescricaoSelosComponent implements OnChanges, OnInit {
  @Input('descricao') descricao: string = "";
  @Input('icon') icon: string = "";

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {

  }
  constructor(private modal: NzModalService, private authService: AuthenticationService) {

  }

}
